module.exports = __webpack_public_path__ + "img/momo_index_button_4.0cabd665.png";